<template lang="pug">
	section(v-bind:class="sectionClass" v-if="!accessToken")
		.section-content
			.alert-box
				.columns.is-centered.is-vcentered.is-mobile
					.column.is-narrow
						img.logo(src="/logo_simple.svg")
					.column.is-narrow
						img.logo.logo-enel(src="/img/enel_logo_small.png")
					.column.last-column
						.has-text-centered
							span.promo(v-html="$t('home.promo_enel')")
							router-link.button.is-primary(to="/promo-code")
								| {{ $t('button.send_coupon') }}

</template>

<script>
export default {
	name : 'SectionCodeEnel',
	props: {
		num: Number
	},
	computed: {
		accessToken() {
			return this.$store.state.auth.accessToken
		},
		language() {
			return this.$t('locale.lang')
		},
		sectionClass() {
			return {
				'section'                : true,
				'promo-code-landing'     : true,
				'border-bottom-section'  : true,
				'section-background-grey': this.num % 2 === 0
			}
		}
	},
	methods: {
		goPromoCode() {
			this.$router.push('/promo-code')
		}
	}
}
</script>
